import { render } from "./RlList.vue?vue&type=template&id=bd2809f8"
import script from "./RlList.vue?vue&type=script&lang=js"
export * from "./RlList.vue?vue&type=script&lang=js"

import "./RlList.vue?vue&type=style&index=0&id=bd2809f8&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__